import React, { useContext, useEffect, useMemo, useState } from 'react'
import AimdFlowQuestionBase from '../../components/aimdFlowQuestionBase'
import { Alert, Backdrop, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, Snackbar, Stack, TextField, Typography, useMediaQuery } from '@mui/material';
import { descriptionStrengthLevels } from '../../data/descriptionStrengthLevels';
import { useNavigate } from 'react-router-dom';
import { DateField, DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import AimdMultiScreenBtn from '../../components/buttons/aimdMultiScreenBtn';
import { useAssessmentApi } from '../../api/assessment';
import APIObjectsContext from '../../context/APIObjectsContext';
import { useQuestionnaireApi } from '../../api/demographics';
import { continueLogic } from '../../routes/continue';
import { AnimationLoadingScreenWithProgressBar } from '../../components/loading/loadingScreen';
import { TermsOfServiceContent } from '../TermsAndPrivacy/termsOfServiceContent';
import { PrivacyContent } from '../TermsAndPrivacy/privacyContent';
import { useTheme } from '@emotion/react';
import ScrollableDatePicker from '../../components/dateInput/scrollableDatePicker';
import { useUserApi } from '../../api/user';
import axios from 'axios';
import { BASE_URL } from '../../api/constants';

const commonTypographyStyles = {
    fontSize: {
        xs: "14px",
        sm: "16px",
        md: "16px",
        lg: "18px"
    },

    fontWeight: 400,
    lineHeight: "27px",
    padding: "0px 5px",
    paddingLeft: { xs: "4px", sm: "6px", lg: "20px" }

};

const AimdSymptomChecker = () => {
    const assessmentApi = useAssessmentApi();
    const theme = useTheme();
    const userApi = useUserApi();
    const isLaptop = useMediaQuery( theme.breakpoints.up( 'lg' ) );
    const navigate = useNavigate();
    const [ canRedirect, setCanRedirect ] = useState( false );
    const [ isLoading, setIsLoading ] = useState( false );
    const [ isServerError, setIsServerError ] = useState( false );
    const isSmallScreen = useMediaQuery( theme => theme.breakpoints.down( 'sm' ) );
    const [ currentStep, setCurrentStep ] = useState( 0 );
    const [ isSymptomValidated, setIsSymptomValidated ] = useState( true );
    const [ isDateValidated, setIsDateValidated ] = useState( true );
    const [ experiencedSymptoms, setExperiencedSymptoms ] = useState( '' );

    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String( today.getMonth() + 1 ).padStart( 2, '0' ); // Months are 0-based, so add 1
        const day = String( today.getDate() ).padStart( 2, '0' );
        return `${ year }-${ month }-${ day }`; // Return today's date as 'YYYY-MM-DD'
    };

    const [ startDate, setStartDate ] = useState(
        isSmallScreen ? getTodayDate() : null
    );
    const [ openModalPrivacy, setOpenModalPrivacy ] = useState( false );
    const [ openModalTerms, setOpenModalTerms ] = useState( false );
    const [ areSymptomsCheckerPresent, setAreSymptomsCheckerPresent ] = useState( null );
    const [ isTermsChecked, setIsTermChecked ] = useState( {
        agreeTerm1: false,
        agreeTerm2: false,
        agreeTerm3: false,
        termsNotAgreedError: false
    } );
    useEffect( () => {
        if ( !canRedirect ) return;
        setIsLoading( false );
        navigate( '/skin-condition' );
    }, [ canRedirect ] );

    // useEffect(() => {
    //     if (startDate === null || startDate === '' || startDate?.format() === 'Invalid Date') return;
    //     const startDateString = startDate?.format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    //     sessionStorage.setItem('symptom-checker-startDate', startDateString);
    // }, [startDate]);

    // useEffect(() => {
    //     if (areSymptomsCheckerPresent === null) return;
    //     sessionStorage.setItem('symptom-checker-areSymptomsCheckerPresent', areSymptomsCheckerPresent);
    // }, [areSymptomsCheckerPresent]);

    // useEffect(() => {
    //     sessionStorage.setItem('symptom-checker-experiencedSymptoms', experiencedSymptoms);
    // }, [experiencedSymptoms]);

    const descriptionStrength = useMemo( () => {
        if ( experiencedSymptoms.length === 0 ) return descriptionStrengthLevels.Empty;
        if ( experiencedSymptoms.length < 70 ) return descriptionStrengthLevels.Low;

        if ( experiencedSymptoms.length >= 70 && experiencedSymptoms.length <= 1000 )
            return descriptionStrengthLevels.Average;

        return descriptionStrengthLevels.High;
    }, [ experiencedSymptoms ] );


    //handle no symptom option selection
    const handleNoSymptom = async () => {
        try {
            setIsLoading( true )
            // Fetch the latest assessment
            const userAssessmentRes = await assessmentApi.getLatestAssessment();
            const userAssessmentID = userAssessmentRes.data.id;

            // Clear any symptom-related session storage items
            sessionStorage.removeItem( 'symptom-checker-experiencedSymptoms' );
            sessionStorage.removeItem( 'symptom-checker-areSymptomsCheckerPresent' );
            sessionStorage.removeItem( 'symptom-checker-startDate' );

            // Reset the assessment data to null (indicating no symptoms)
            await assessmentApi.patchAssessment( userAssessmentID, null, null );

            // Post the Radha's assessment diagnosis with the latest assessment ID
            await assessmentApi.postRadhasAssessmentDiagnose( userAssessmentID );
            setIsLoading( false )
            // Determine the next page to navigate to using continueLogic
            const nextPage = await continueLogic( assessmentApi );
            navigate( nextPage );

            return;
        } catch ( error ) {
            setIsLoading( false )
            // Catch and log any errors that occur during the process
            console.error( "Error in handleNoSymptom:", error );
            setIsServerError( true );
        }
    };

    const handleUserConsent = async ( isConsent ) => {
        console.log( "Submitting user consent:", isConsent );
        try {
            setIsLoading( true );

            // Parse token from authTokens object in localStorage
            const authTokenRaw = localStorage.getItem( 'authTokens' );
            const accessToken = authTokenRaw ? JSON.parse( authTokenRaw ).access_token : null;

            if ( !accessToken ) {
                throw new Error( "No access token found in localStorage" );
            }

            const response = await axios.post(
                `${BASE_URL}/user/user-consent`,
                { is_consent: isConsent },
                {
                    headers: {
                        'Authorization': `Bearer ${ accessToken }`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            console.log( "Consent submitted successfully", response.data );
            setIsLoading( false );
            return response.data;
        } catch ( error ) {
            console.error( "Failed to submit user consent:", error );
            setIsLoading( false );
            setIsServerError( true );
            throw error;
        }
    };






    //handle post assessment & navigate
    const handleNext = async () => {
        try {
            // Validate experiencedSymptoms and startDate
            const experiencedSymptomsConditions = experiencedSymptoms !== '' && experiencedSymptoms.length >= 70 && experiencedSymptoms.length <= 1500;
            // const startDateConditions = startDate !== null && startDate !== undefined && startDate !== '' && !startDate.isAfter(dayjs());
            const startDateConditions = (
                startDate !== null &&
                startDate !== undefined &&
                startDate !== '' &&
                ( !isSmallScreen || !dayjs( startDate ).isAfter( dayjs() ) )
            );
            // If both conditions are met, proceed with the API calls
            if ( experiencedSymptomsConditions && startDateConditions ) {
                setCurrentStep( 2 );
                // setIsLoading(true)
                // // Fetch the latest assessment
                // const userAssessmentRes = await assessmentApi.getLatestAssessment();
                // let userAssessmentID = userAssessmentRes.data.id;

                // // Update assessment data with the symptoms and start date
                // await assessmentApi.patchAssessment(userAssessmentID, experiencedSymptoms, startDate);
                // await assessmentApi.postRadhasAssessmentDiagnose(userAssessmentID);
                // setCurrentStep(2);
                // // // Determine the next page and navigate
                // // const nextPage = await continueLogic(assessmentApi);
                // // setIsLoading(false)
                // // navigate(nextPage);
            }
            // Set the validation states after performing the checks
            setIsSymptomValidated( experiencedSymptomsConditions );
            setIsDateValidated( startDateConditions );

        } catch ( error ) {
            setIsLoading( false )
            // General error handling for any async operations
            console.error( "An error occurred during the assessment flow:", error );
            setIsServerError( true );
        }
    };

    //Handle agree terms & condition logic
    const handleCheckboxChange = ( event ) => {
        const { name, checked } = event.target;

        // Update the specific checkbox without affecting the others
        setIsTermChecked( ( prevState ) => ( {
            ...prevState,
            [ name ]: checked,
        } ) );
    };

    const backButtonHandler = () => {
        if ( currentStep === 1 ) {
            setCurrentStep( 0 );
        } else {
            navigate( '/pre-face-scan' )
        }
    }

    //handle yes no selection
    const handleOptionSelect = ( value ) => {
        setAreSymptomsCheckerPresent( value );
        if ( value ) {
            setCurrentStep( ( prev ) => prev + 1 );
        } else {
            setCurrentStep( 2 );
        }
    };

    const onNextClickHandler = async () => {
        handleNext()
        // setCurrentStep(2);

    }

    const submittData = async () => {
        console.log( experiencedSymptoms, startDate );
        if ( isTermsChecked.agreeTerm1 && isTermsChecked.agreeTerm2 ) {
            try {
                await handleUserConsent( isTermsChecked.agreeTerm3 ); // send true or false
                // Validate experiencedSymptoms and startDate
                const experiencedSymptomsConditions = experiencedSymptoms !== '' && experiencedSymptoms.length >= 70 && experiencedSymptoms.length <= 1500;
                const startDateConditions = startDate !== null &&
                    startDate !== undefined &&
                    startDate !== '' &&
                    ( !isSmallScreen ? !startDate.isAfter( dayjs() ) : true );
                // // If both conditions are met, proceed with the API calls
                if ( experiencedSymptomsConditions && startDateConditions ) {
                    setIsLoading( true )
                    // Fetch the latest assessment
                    const userAssessmentRes = await assessmentApi.getLatestAssessment();
                    let userAssessmentID = userAssessmentRes.data.id;

                    // Update assessment data with the symptoms and start date
                    await assessmentApi.patchAssessment( userAssessmentID, experiencedSymptoms, startDate );
                    await assessmentApi.postRadhasAssessmentDiagnose( userAssessmentID );
                    // Determine the next page and navigate
                    const nextPage = await continueLogic( assessmentApi );
                    setIsLoading( false )
                    navigate( nextPage );
                } else {
                    handleNoSymptom()
                }
            } catch ( error ) {
                setIsLoading( false )
                // General error handling for any async operations
                console.error( "An error occurred during the assessment flow:", error );
                setIsServerError( true );
            }
        } else {
            setIsTermChecked( ( prevState ) => ( {
                ...prevState,
                termsNotAgreedError: true,
            } ) );
        }
    }

    //Handles action to close terms of use modal dialog
    const closeTermsModal = isClose => {
        setOpenModalTerms( isClose );
    };

    //Handles action to close privacy policy modal dialog
    const closePrivacyPolicyModal = isClose => {
        setOpenModalPrivacy( isClose );
    };

    //Handles action to open privacy policy modal dialog
    const handlePrivacyPolicy = () => {
        setOpenModalPrivacy( true );
    };

    //Handles action to open terms of use modal dialog
    const handleTermsOfUse = () => {
        setOpenModalTerms( true );
    };

    const renderStep1 = () => (
        <Box>
            <Typography
                sx={ {
                    lineHeight: '27px',
                    textAlign: 'center',
                    mb: { lg: 3, xs: 2 },
                    fontSize: { lg: "25px", md: "23px" },
                    textAlign: "center",
                    color: "#000",
                    fontFamily: "Poppins",
                    fontWeight: "700",
                } }
            >
                Are you experiencing any health symptoms?
            </Typography>
            <Stack
                sx={ {
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    // mt: 3
                } }
            >
                { [
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                ].map( ( option, index ) => (
                    // <OptionButton
                    //     key={index}
                    //     option={option.label}
                    //     onClick={() => handleOptionSelect(option.value)}
                    // />
                    <Button
                        key={ index }
                        sx={ {
                            width: {
                                xs: '280px',
                                sm: '300px',
                                md: '400px',
                                lg: '450px'

                            },
                            background: areSymptomsCheckerPresent === option.value ? "linear-gradient(92deg, #72D8DA 2.79%, #35C6C9 90.54%)" : "rgba(114, 216, 218, 0.15)",
                            color: areSymptomsCheckerPresent === option.value ? "white !important" : "#35C6C9",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "30px",
                            marginBottom: "10px",
                            height: {
                                xs: "60px",
                                sm: "60px",
                                md: "60px",
                                lg: "60px"

                            },
                            // marginY: "0.5rem",
                            // padding : "0px",
                            transition: "all 0.3s ease",
                            "&:hover": {
                                background: areSymptomsCheckerPresent === option.value ? "linear-gradient(92deg, #72D8DA 2.79%, #35C6C9 90.54%)" : "rgba(114, 216, 218, 0.15)",
                                color: areSymptomsCheckerPresent === option.value ? "white !important" : "#35C6C9",
                                borderRadius: "30px",
                                boxShadow: "0px 8px 19px 0px rgba(0, 0, 0, 0.10)"

                            },

                        } }
                        onClick={ () => handleOptionSelect( option.value ) }>
                        <Typography
                            // color="#000"
                            display="block"
                            sx={ {
                                width: "100%",
                                // fontSize: isLaptop ? "18px" : "15px",
                                fontSize: { xs: "15px", lg: "18px" },
                                fontWeight: "500",
                                lineHeight: "22.5px",
                                textAlign: "center",
                            } }>
                            { option.label }
                        </Typography>
                    </Button>
                ) ) }

            </Stack>
        </Box>
    );

    const renderStep2 = () => (

        <Box

            sx={ {
                maxWidth: "500px",
                fontFamily: "Poppins",
                minWidth: {
                    xs: "90%",
                    sm: "400px",
                    md: "450px",
                    lg: "500px"

                },
                mt: {
                    xs: '20px',
                    sm: '50px',
                    md: '50px'
                }
            } }
        >
            <Typography
                sx={ {
                    fontSize: {
                        xs: '20px',
                        sm: '23px',
                        md: '23px',// Larger font for laptop screens
                        lg: '25px',
                    },

                    fontWeight: '700',
                    lineHeight: '27px',
                    textAlign: 'center',
                    mb: 1
                } }
            >Can you tell us more?</Typography>
            <Typography
                sx={ {
                    fontSize: "14px",
                    fontWeight: '400',
                    lineHeight: '18px',
                    textAlign: 'center'
                } }
            >
                In as much detail as you can, please tell us about the symptoms you’ve been experiencing.
            </Typography>

            <Box sx={ { marginTop: { lg: 3, md: 2, sm: "12px", xs: "12px" }, width: '100%', maxWidth: 500, mx: 'auto' } }>

                <TextField
                    id="outlined-multiline-static"
                    label=""
                    multiline
                    inputProps={ {
                        maxLength: 1500,
                    } }
                    placeholder='e.g., I have a runny nose, a sore throat and a cough that my mom can hear from the attic. '
                    rows={ isSmallScreen ? 5 : 8 }

                    sx={ {
                        '& .MuiInputBase-root': {
                            // color : "red",
                            border: '1px solid #72D8DA', // Gray border
                            borderRadius: '8px', // Rounded corners
                            backgroundColor: 'rgba(237, 249, 249, 0.50)'
                        },
                        // Remove the bottom border if Material UI is adding it
                        '& .MuiInputBase-root:before': {
                            borderBottom: 'none !important', // Remove bottom border if necessary
                        },
                        '& .MuiInputBase-root:after': {
                            borderBottom: 'none !important', // Prevent any underline from appearing
                        },
                        // Hover styling (optional, if you want to change border on hover)
                        '& .MuiInputBase-root:hover': {
                            border: '2px solid #72D8DA', // Light blue border on hover (optional)
                        },
                        // Input field text padding
                        '& .MuiInput-input': {
                            pt: 1, // Padding-top
                            px: 1, // Padding-left and padding-right
                        },
                        // // Helper text background color
                        '& .MuiFormHelperText-root': {
                            backgroundColor: '#FFFFFF',

                        },
                        '& .MuiInputBase-input::placeholder': {
                            color: '#35C6C9',  // Change placeholder text color
                            backgroundColor: "white",
                            fontWeight: 500,
                            // fontStyle: 'italic',  // Example: make the placeholder text italic
                            fontSize: {
                                xs: "14px",
                                md: "16px",
                                lg: "16px"
                            }
                        },
                    } }

                    defaultValue={ experiencedSymptoms }
                    fullWidth
                    variant="standard"
                    onChange={ event => {
                        setExperiencedSymptoms( event.target.value );
                    } }
                    error={ !isSymptomValidated ? true : false }
                    helperText={ ( () => {
                        if ( isSymptomValidated ) return;
                        if ( experiencedSymptoms === '' ) return 'Please type the symptoms you are experiencing.';
                        if ( experiencedSymptoms.length < 70 || experiencedSymptoms.length > 1500 ) return '';
                    } )() }
                />
                <Typography variant="body1" pt={ 1 } sx={ { fontSize: { xs: "12px", lg: "14px", md: "14px" } } }>
                    <span style={ { fontWeight: 'bold' } }>Description strength:</span>{ ' ' }
                    <span
                        style={ {
                            fontWeight: 'bold',
                            color: descriptionStrength.color,
                        } }
                    >
                        { descriptionStrength.title }
                    </span>
                    <br />
                    <span>{ descriptionStrength.text }</span>
                </Typography>
            </Box>
            <Box md={ 5 } sx={ { marginTop: { lg: 4, xs: 2 }, } }>
                <Typography variant="subtitle0" textAlign="center">
                    When did this start?
                </Typography>
            </Box>
            <Box md={ 5 }
                sx={ {
                    marginTop: 1,
                    width: '100%',
                } }>
                <Stack>
                    <LocalizationProvider dateAdapter={ AdapterDayjs }>
                        { isSmallScreen ? (
                            <Box sx={ { marginTop: "40px" } }>
                                <ScrollableDatePicker
                                    selctedTextcolor='#35C6C9'
                                    nonSelctedTextColor="rgb(194,238,239)"
                                    selctedDateAreaBg="rgba(114, 216, 218, 0.20)"
                                    isAimdFlow="true"
                                    isSmallDevice="true"
                                    onDateChange={ update => {
                                        setStartDate( update );
                                    } }
                                    initialDate={ startDate }
                                // initialDate={null}
                                />
                            </Box>
                        ) : (
                            <DatePicker
                                disableFuture
                                isClearable={ true }
                                value={ startDate === null || startDate === '' ? null : startDate }
                                onChange={ update => {
                                    setStartDate( update );
                                } }
                                sx={ {
                                    borderColor: "#72D8DA",
                                    '& .MuiInputBase-root, & .MuiOutlinedInput-root': {
                                        padding: "0px 20px",
                                        color: "#72D8DA",
                                        fontWeight: "500",
                                        fontSize: "16px",
                                        borderRadius: '40px',
                                        '& input::placeholder': {
                                            color: '#72D8DA',
                                            opacity: 1,
                                            textAlign: 'left',
                                            fontWeight: 500,
                                        },

                                    },
                                    '& .MuiOutlinedInput-root.Mui-focused': {
                                        borderColor: '#72D8DA',
                                        borderWidth: '2px',
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        border: "1px solid #72D8DA"
                                    },
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        border: 'none',
                                    },
                                    '& svg': {
                                        fill: '#72D8DA',
                                        width: '24px',
                                        height: '24px',
                                    },

                                } }

                            />
                        )

                        }
                    </LocalizationProvider>
                    { ( () => {
                        if ( isDateValidated ) return;

                        let errorMessage = '';
                        if ( startDate === null || startDate === undefined || startDate === '' ) errorMessage = 'Choose a date';
                        else if ( !isSmallScreen && startDate.isAfter( dayjs() ) ) errorMessage = "You can't choose a date in the future!";

                        return (
                            <Typography variant="caption" color="error" display="block" marginTop={ isSmallScreen && "25px" } gutterBottom>
                                { errorMessage }
                            </Typography>
                        );
                    } )() }
                </Stack>
            </Box>
            <Box sx={ {
                display: "flex",
                alignItem: "center",
                justifyContent: "center",
                width: "100%",
            } }
            >
                <Box sx={ {
                    display: "flex",
                    alignItem: "center",
                    justifyContent: "center",
                    width: "100%",
                    mt: {
                        xs: "60px",
                        lg: "30px"
                    },
                    maxWidth: "321px",
                    width: "100%",
                    height: {
                        xs: '20px',
                        sm: '30px',
                        md: '50px',
                        lg: "65px"
                    },


                } }>
                    <AimdMultiScreenBtn onClick={ onNextClickHandler }></AimdMultiScreenBtn>
                </Box>
            </Box>
        </Box>
    );


    const renderStep3 = () => (
        <Box sx={
            {
                padding: {
                    lg: "20px 200px",
                    md: "20px 100px",
                    sm: "20px 30px",
                    xs: "20px 20px"
                }
            }
        }>
            {/* 1st Terms checkbox */ }
            <Box>
                <FormControlLabel
                    sx={ {
                        display: 'flex',
                        alignItems: 'flex-start'
                    } }
                    control={
                        <Checkbox
                            name="agreeTerm1"
                            checked={ isTermsChecked.agreeTerm1 }
                            onChange={ handleCheckboxChange }
                            color="primary"
                            sx={ { padding: { xs: "6px", lg: "10px", md: "9px" }, marginTop: "-4px" } }
                        />
                    }
                    label={
                        <Box alignItems="center" >
                            <Typography sx={ commonTypographyStyles } color="#000000"  >
                                I understand the information provided in this assessment is not intended for the diagnosis treatment or prevention of disease, but rather to provide me general information about my health and products that may be able to improve my wellbeing.
                            </Typography>
                        </Box>
                    }
                // Optional styling
                />
            </Box>

            {/* 2nd terms checkbox */ }
            <Box sx={ {
                pt: {
                    xs: "8px",
                    sm: "8px",
                    md: "14px",
                    lg: "25px"

                }
            } }>
                <FormControlLabel
                    sx={ {
                        display: 'flex',
                        alignItems: 'flex-start'
                    } }

                    control={
                        <Checkbox
                            name="agreeTerm2"
                            checked={ isTermsChecked.agreeTerm2 }
                            onChange={ handleCheckboxChange }
                            color="primary"
                            sx={ { padding: { xs: "6px", lg: "10px", md: "9px" }, marginTop: "-4px" } }
                        />
                    }
                    label={
                        <Box alignItems="center" >
                            <Typography color="#000000" sx={ commonTypographyStyles }>
                                I have read and understood the
                                <Button onClick={ handleTermsOfUse } sx={ {
                                    color: '#72D8DA', textDecoration: 'underline', fontWeight: "600", padding: "0px 6px", fontSize: {
                                        xs: "14px",
                                        sm: "16px",
                                        md: "16px",
                                        lg: "18px"
                                    }
                                } } > terms of use</Button>
                                <span style={ {
                                    color: '#000000', fontSize: {
                                        xs: "14px",
                                        sm: "16px",
                                        md: "16px",
                                        lg: "16px"
                                    }
                                } }> and</span>
                                <Button onClick={ handlePrivacyPolicy } sx={ {
                                    color: '#72D8DA', textDecoration: 'underline', fontWeight: "600", padding: "0px 6px", fontSize: {
                                        xs: "16px",
                                        sm: "16px",
                                        md: "16px",
                                        lg: "18px"
                                    }
                                } } > privacy policy</Button>
                            </Typography>
                        </Box>
                    }

                />

            </Box>
            {/* 3rd checkbox - Data consent */ }
            <Box sx={ {
                pt: {
                    xs: "8px",
                    sm: "8px",
                    md: "14px",
                    lg: "25px"
                }
            } }>
                <FormControlLabel
                    sx={ {
                        display: 'flex',
                        alignItems: 'flex-start'
                    } }
                    control={
                        <Checkbox
                            name="agreeTerm3"
                            checked={ isTermsChecked.agreeTerm3 }
                            onChange={ handleCheckboxChange }
                            color="primary"
                            sx={ {
                                padding: { xs: "6px", lg: "10px", md: "9px" },
                                marginTop: "-4px"
                            } }
                        />
                    }
                    label={
                        <Box alignItems="center">
                            <Typography sx={ commonTypographyStyles } color="#000000">
                                I consent to the use of my personal data collected by AI-MD for purposes of research and for providing personalized information and services.
                            </Typography>
                        </Box>
                    }
                />
            </Box>

            <Box sx={ {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                width: "100%"
            } }>
                <Box

                    sx={ {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        mt: {
                            xs: '30px',
                            sm: '30px',
                            md: '40px',
                            lg: "50px"
                        },
                        maxWidth: "321px",
                        width: "100%",
                        height: {
                            xs: '20px',
                            sm: '30px',
                            md: '50px',
                            lg: "65px"
                        },
                    } }

                >

                    <AimdMultiScreenBtn onClick={ submittData } btnText="Get Results"></AimdMultiScreenBtn>


                </Box>
            </Box>

        </Box>
        // </StepContainer >
    );

    const renderStep = () => {
        switch ( currentStep ) {
            case 0:
                return renderStep1();
            case 1:
                return renderStep2();
            case 2:
                return renderStep3();
            default:
                return null;
        }
    };


    return (
        <>
            { isLoading ? <AnimationLoadingScreenWithProgressBar
                title="Loading..."
            /> :
                <>
                    <AimdFlowQuestionBase
                        IsShowBackIcon={ true }
                        isShowMenuIcon={ true }
                        backButtonHandler={ backButtonHandler }
                        aimdLinearBarValue={ ( currentStep + 1 ) * ( 100 / 3 ) }
                    >
                        { renderStep() }

                    </AimdFlowQuestionBase>
                    {
                        <Snackbar
                            open={ isServerError }
                            autoHideDuration={ 3000 }
                            onClose={ () => setIsServerError( false ) }
                            anchorOrigin={ {
                                vertical: 'top',
                                horizontal: 'center'
                            } }
                        >
                            <Alert
                                variant="filled"
                                severity="error"
                                sx={ {
                                    display: 'flex',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    mb: 8,
                                    fontSize: {
                                        xs: 16,
                                        sm: 18
                                    },
                                    px: {
                                        xs: 2,
                                        sm: 5
                                    },
                                    borderRadius: 3
                                } }
                            >
                                An error occurred.Please
                                try again later.
                            </Alert>
                        </Snackbar>



                    }
                    {
                        <Snackbar
                            open={ isTermsChecked.termsNotAgreedError }
                            autoHideDuration={ 3000 }
                            onClose={ () => {
                                setIsTermChecked( ( prevState ) => ( {
                                    ...prevState,
                                    termsNotAgreedError: false,
                                } ) );
                            } }
                            anchorOrigin={ {
                                vertical: 'top',
                                horizontal: 'center'
                            } }
                        >
                            <Alert
                                variant="filled"
                                severity="error"
                                sx={ {
                                    display: 'flex',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    mb: 8,
                                    fontSize: {
                                        xs: 16,
                                        sm: 18
                                    },
                                    px: {
                                        xs: 2,
                                        sm: 5
                                    },
                                    borderRadius: 3
                                } }
                            >
                                You must agree to terms and conditions to continue.
                            </Alert>
                        </Snackbar>
                    }
                    {/* Modal box when user clicks terms of use link */ }
                    <Dialog
                        open={ openModalTerms }
                        maxWidth="sm"
                        closeAfterTransition
                        BackdropComponent={ Backdrop }
                        BackdropProps={ {
                            timeout: 500,
                        } }
                        PaperProps={ {
                            sx: {
                                borderRadius: '30px',
                                position: 'absolute',
                                mx: {
                                    xs: 2,
                                    md: 'auto',
                                },
                            },
                        } }
                        sx={ {
                            top: theme.spacing( 5 ),
                            paddingY: theme.spacing( 2 ),
                            '& .MuiDialog-paperScrollPaper': {
                                borderRadius: 5,
                            },
                        } }
                    >
                        <DialogTitle sx={ { paddingY: theme.spacing( 3 ) } }>
                            <Typography component="span" variant="h6">
                                TERMS OF SERVICE AGREEMENT
                            </Typography>
                        </DialogTitle>
                        <DialogContent
                            sx={ {
                                paddingY: theme.spacing( 5 ),
                                paddingRight: theme.spacing( 3 ),
                            } }
                        >
                            <TermsOfServiceContent />
                        </DialogContent>
                        <DialogActions sx={ { paddingBottom: theme.spacing( 2 ) } }>
                            <Button variant="text" onClick={ () => closeTermsModal( false ) }>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                    {/* Modal box when user clicks privacy policy link */ }
                    <Dialog
                        open={ openModalPrivacy }
                        maxWidth="sm"
                        closeAfterTransition
                        BackdropComponent={ Backdrop }
                        BackdropProps={ {
                            timeout: 500,
                        } }
                        PaperProps={ {
                            sx: {
                                borderRadius: '30px',
                                position: 'absolute',
                                mx: {
                                    xs: 2,
                                    md: 'auto',
                                },
                            },
                        } }
                        sx={ {
                            top: theme.spacing( 5 ),
                            paddingY: theme.spacing( 2 ),
                            '& .MuiDialog-paperScrollPaper': {
                                borderRadius: 5,
                            },
                        } }
                    >
                        <DialogTitle sx={ { paddingY: theme.spacing( 3 ) } }>
                            <Typography component="span" variant="h6">
                                PRIVACY POLICY
                            </Typography>
                        </DialogTitle>
                        <DialogContent
                            sx={ {
                                paddingY: theme.spacing( 5 ),
                                paddingRight: theme.spacing( 3 ),
                            } }
                        >
                            <PrivacyContent isPage={ false } />
                        </DialogContent>
                        <DialogActions sx={ { paddingBottom: theme.spacing( 2 ) } }>
                            <Button variant="text" onClick={ () => closePrivacyPolicyModal( false ) }>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            }</>
    )
}

export default AimdSymptomChecker